import { styled } from "../styling";
export const ModalBody = styled.div.attrs({
    className: "modal-body",
}) `
  overflow: visible;
`;
//# sourceMappingURL=ModalBody.js.map